import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '漫画分类', href: '/category/all' },
    { label: '关于我们', href: '/about' },
  ],
  categories: [
    { label: '恋爱漫画', href: '/category/romance' },
    { label: '奇幻漫画', href: '/category/fantasy' },
    { label: '热血漫画', href: '/category/action' },
    { label: '都市漫画', href: '/category/drama' },
    { label: '悬疑漫画', href: '/category/thriller' },
  ],
  support: [
    { label: '常见问题', href: '/about#faq' },
    { label: '联系我们', href: '/about#contact' },
    { label: '用户协议', href: '/' },
    { label: '隐私政策', href: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-background-50 whitespace-nowrap">
                虫虫漫画
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              沉浸式韩国漫画阅读体验平台，为您带来最优质的二次元内容。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-100/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 虫虫漫画 版权所有 | 沉浸式韩国漫画体验平台
          </p>
          <p className="text-sm text-background-500">
            联系邮箱：support@chongchongmanga.com
          </p>
        </div>
      </div>
    </footer>
  );
}